<div class="overflow-hidden pb-24 md:pb-10 bg-white">
  <div class="breadcrum-container w-full px-4 sm:px-6 lg:px-8 pt-1.5 pb-1 sm:pt-4 bg-white">
    <app-breadcrum [data]="bookingBreadcrumbs"></app-breadcrum>
  </div>

  <main class="flex flex-col px-4 sm:px-6 lg:px-8 mt-2 md:mt-4 w-full max-md:max-w-full">
    <section class="w-full max-md:max-w-full" [attr.space]="24">
      <div class="flex gap-5 max-md:gap-1 max-md:flex-col">
        <div class="w-[43%] max-md:ml-0 max-md:w-full">
          <article
            class="flex overflow-hidden gap-2 items-center p-4 w-full bg-white rounded-2xl sm:border sm:border-solid sm:border-[color:var(--Input-field-Stroke,#D4D4D4)] max-md:px-1 max-md:mt-6">
            <div class="self-stretch my-auto min-w-60 w-[545px] max-md:max-w-full">
              <section class="flex flex-col sm:flex-row gap-2 items-start w-full max-md:max-w-full">
                <div class="flex flex-col justify-center p-2 rounded border border-solid cursor-pointer"
                  [class.bg-slate-50]="!isStorePickup" [class.border-[#307FE1]]="!isStorePickup"
                  [class.bg-white]="isStorePickup" [class.border-[#D4D4D4]]="isStorePickup"
                  (click)="toggleDeliveryMethod(false)" class="w-full sm:w-[178px] cursor-pointer">
                  <div
                    class="flex flex-col w-full rounded max-md:rounded-md p-2 border border-solid border-[color:var(--Input-field-Stroke,#D4D4D4)] cursor-pointer">
                    <div class="flex gap-1 items-start self-start">
                      <div class="flex gap-1 items-center w-6">
                        <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg"
                          class="w-5 h-5">
                          <path
                            d="M10.832 10.8334V4.16671M10.832 10.8334H12.4987M10.832 10.8334H7.91536M3.33203 10.8334H4.58203M10.832 4.16671V1.66671C10.832 1.20647 10.4589 0.833374 9.9987 0.833374H3.33203C2.87179 0.833374 2.4987 1.20647 2.4987 1.66671V3.33337M10.832 4.16671H14.3083C14.7504 4.16671 15.1743 4.3423 15.4869 4.65486L17.0105 6.17855C17.3231 6.49111 17.4987 6.91504 17.4987 7.35706V10C17.4987 10.4603 17.1256 10.8334 16.6654 10.8334H15.832M7.91536 10.8334C7.91536 11.7538 7.16917 12.5 6.2487 12.5C5.32822 12.5 4.58203 11.7538 4.58203 10.8334M7.91536 10.8334C7.91536 9.9129 7.16917 9.16671 6.2487 9.16671C5.32822 9.16671 4.58203 9.9129 4.58203 10.8334M15.832 10.8334C15.832 11.7538 15.0858 12.5 14.1654 12.5C13.2449 12.5 12.4987 11.7538 12.4987 10.8334M15.832 10.8334C15.832 9.9129 15.0858 9.16671 14.1654 9.16671C13.2449 9.16671 12.4987 9.9129 12.4987 10.8334M2.4987 3.33337H5.83203M2.4987 3.33337H0.832031M7.4987 5.83337H2.4987M2.91536 8.33337H1.66536"
                            [attr.stroke]="!isStorePickup ? '#307FE1' : 'black'" stroke-width="1.66667"
                            stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </div>
                      <h3 class="text-base font-bold" [class.text-blue-500]="!isStorePickup"
                        [class.text-black]="isStorePickup">
                        Home Delivery
                      </h3>
                    </div>
                    <p
                      class="gap-2 self-stretch pl-7 mt-1 text-xs font-medium leading-tight text-neutral-500 max-md:pl-5 whitespace-nowrap">
                      <span style="font-size: 12px; line-height: 16px">
                        Get Delivery by
                      </span>
                      <span style="font-weight: 700; font-size: 12px; line-height: 16px; color: rgba(0, 0, 0, 1);">
                        24th Feb
                      </span>
                    </p>
                  </div>
                </div>

                <div class="flex flex-col justify-center p-2 rounded border border-solid cursor-pointer"
                  [class.bg-slate-50]="isStorePickup" [class.border-[#307FE1]]="isStorePickup"
                  [class.bg-white]="!isStorePickup" [class.border-[#D4D4D4]]="!isStorePickup"
                  (click)="toggleDeliveryMethod(true)" class="w-full sm:w-[190px] cursor-pointer">
                  <div
                    class="flex flex-col items-start w-full rounded max-md:rounded-md p-2 border border-solid border-[color:var(--Input-field-Stroke,#D4D4D4)] cursor-pointer">
                    <div class="flex gap-1 items-start">
                      <div class="flex gap-1 items-center w-6">
                        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"
                          class="w-5 h-5">
                          <path
                            d="M14.4189 7.26722V13.3334C14.4189 14.7141 13.251 15.8334 11.8103 15.8334H10.5059M14.4189 7.26722C14.7511 7.10329 15.0833 6.85535 15.3671 6.61151C15.8804 6.17035 15.959 5.4519 15.6507 4.8609L14.2704 2.21534C13.8285 1.36838 12.9252 0.833374 11.9371 0.833374H4.72693C3.73883 0.833374 2.83554 1.36838 2.39365 2.21534L1.01337 4.8609C0.705028 5.4519 0.783708 6.17035 1.29701 6.61151C1.58072 6.85535 1.91292 7.10329 2.24512 7.26722M14.4189 7.26722C14.1336 7.40802 13.8371 7.50004 13.5494 7.50004C11.8103 7.50004 10.9407 5.83337 10.9407 5.83337C10.9407 5.83337 10.0711 7.50004 8.33203 7.50004C6.59291 7.50004 5.72335 5.83337 5.72335 5.83337C5.72335 5.83337 4.85379 7.50004 3.11468 7.50004C2.82697 7.50004 2.53044 7.40802 2.24512 7.26722M2.24512 7.26722V13.3334C2.24512 14.7141 3.41306 15.8334 4.85379 15.8334H6.15813M6.15813 15.8334V11.6667C6.15813 11.2065 6.54745 10.8334 7.02769 10.8334H9.63637C10.1166 10.8334 10.5059 11.2065 10.5059 11.6667V15.8334M6.15813 15.8334H10.5059"
                            [attr.stroke]="isStorePickup ? '#307FE1' : 'black'" stroke-width="1.66667"
                            stroke-linejoin="round" />
                        </svg>
                      </div>
                      <h3 class="text-base font-bold" [class.text-blue-500]="isStorePickup"
                        [class.text-black]="!isStorePickup">
                        Store Pickup
                      </h3>
                    </div>
                    <p
                      class="gap-2 self-stretch pl-7 mt-1 text-xs font-medium leading-tight text-neutral-500 max-md:pl-5 whitespace-nowrap">
                      <span style="font-size: 12px; line-height: 16px">
                        Pickup after
                      </span>
                      <span style="font-weight: 700; font-size: 12px; line-height: 16px; color: rgba(0, 0, 0, 1);">
                        24th Feb
                      </span>
                    </p>
                  </div>
                </div>
              </section>
              <section class="mt-4 w-full max-md:max-w-full">
                <div class="flex sm:flex-row max-md:flex-row gap-2 items-start w-full min-h-[132px] max-md:max-w-full"
                  *ngFor="let selectedProduct of products">
                  <div
                    class="overflow-hidden text-sm font-bold leading-none text-green-700 whitespace-nowrap rounded-md w-[170px]">
                    <div
                      class="flex overflow-hidden relative flex-col items-start px-1 pt-1 pb-28 w-full aspect-[1.348] max-md:pr-5 max-md:pb-24">
                      <img
                        [src]="selectedProduct?.part_image_path?.[0] || 'https://cdn.builder.io/api/v1/image/assets/TEMP/6a0e0ecd064d7a784992bdafb1d4d589fbb748d0?placeholderIfAbsent=true&apiKey=7a515686e3e54f1fa59f8a8a2c80ed68'"
                        class="object-cover absolute inset-0 size-full" alt="Product image" />
                      <div *ngIf="selectedProduct?.quality_s"
                        class="flex relative gap-1 items-center px-1 py-0.5 mb-0 rounded max-md:mb-2.5" [ngClass]="
                          selectedProduct?.quality_s === 'A' ? 'bg-green-100 text-green-800' :
                          selectedProduct?.quality_s === 'B' ? 'bg-yellow-100 text-yellow-800' :
                          selectedProduct?.quality_s === 'C' ? 'bg-orange-100 text-orange-800' : 'bg-green-100 text-green-800'
                        ">
                        <svg *ngIf="selectedProduct?.quality_s"
                          [attr.title]="'Quality grade: ' + selectedProduct.quality_s" width="20" height="20"
                          viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                          class="max-sm:w-4 max-sm:h-4">
                          <rect width="24" height="24" rx="4" [attr.fill]="
                              selectedProduct?.quality_s === 'A' ? '#01811D' :
                              selectedProduct?.quality_s === 'B' ? '#B8860B' :
                              selectedProduct?.quality_s === 'C' ? '#D35400' : '#01811D'
                            " />
                          <text [attr.x]="12" [attr.y]="16" text-anchor="middle" font-size="14"
                            font-family="Arial, sans-serif" fill="white">
                            {{ selectedProduct.quality_s }}
                          </text>
                        </svg>
                        <span class="self-stretch my-auto text-xs font-bold" [ngClass]="
                            selectedProduct?.quality_s === 'A' ? 'text-green-800' :
                            selectedProduct?.quality_s === 'B' ? 'text-yellow-800' :
                            selectedProduct?.quality_s === 'C' ? 'text-orange-800' : 'text-green-800'
                          ">
                          Quality
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="flex flex-col flex-1 shrink items-start basis-0 min-w-60">
                    <div class="self-stretch w-full">
                      <h2 class="text-base font-bold text-black text-ellipsis-1-line">
                        {{ selectedProduct?.table_name || 'Product Name' }}
                      </h2>
                      <div
                        class="flex flex-wrap gap-1 items-center mt-1 w-full text-sm max-md:text-xs font-medium leading-none text-zinc-700">
                        <span class="self-stretch my-auto text-zinc-700" *ngIf="selectedProduct?.make">
                          {{ selectedProduct.make }}
                        </span>
                        <span class="self-stretch my-auto text-zinc-700" *ngIf="selectedProduct?.model">
                          {{ selectedProduct.model }}
                        </span>
                        <span class="self-stretch my-auto text-zinc-700" *ngIf="selectedProduct?.year_of_manufacture">
                          {{ selectedProduct.year_of_manufacture }}
                        </span>
                        <span class="self-stretch my-auto text-zinc-700" *ngIf="selectedProduct?.variant">
                          {{ selectedProduct.variant }}
                        </span>
                      </div>
                    </div>

                    <div class="flex gap-2 items-center sm:mt-2 text-base font-bold"
                      *ngIf="selectedProduct?.part_type !== 'Scrap Part'">
                      <span class="self-stretch my-auto text-black">
                        {{ formatCurrency(selectedProduct?.discounted_price || selectedProduct?.price_s || 0) }}
                      </span>
                      <span class="self-stretch my-auto font-medium text-neutral-500"
                        *ngIf="selectedProduct.discount_percentage > 0">
                        <span style="text-decoration: line-through; color: rgba(119, 119, 119, 1);">
                          {{ formatCurrency(selectedProduct.price_s) }}
                        </span>
                      </span>
                      <span
                        class="gap-2 self-stretch px-2 py-1 text-xs leading-none text-white bg-emerald-800 min-h-6 rounded-[40px]"
                        *ngIf=" selectedProduct.discount_percentage > 0">
                        {{selectedProduct.discount_percentage}}% Off
                      </span>
                    </div>
                    <div class="flex gap-2 items-center sm:mt-2 text-base font-bold"
                      *ngIf="selectedProduct?.part_type === 'Scrap Part'">
                      <span class="self-stretch my-auto text-black">
                        {{ formatCurrency(selectedProduct?.discounted_taxable ? selectedProduct?.discounted_taxable :
                        selectedProduct?.taxable_amount) }}
                      </span>
                      <span class="self-stretch my-auto font-medium text-neutral-500"
                        *ngIf="selectedProduct.discount_percentage > 0">
                        <span style="text-decoration: line-through; color: rgba(119, 119, 119, 1);">
                          {{ formatCurrency(selectedProduct?.taxable_amount) }}
                        </span>
                      </span>
                      <span
                        class="gap-2 self-stretch px-2 py-1 text-xs leading-none text-white bg-emerald-800 min-h-6 rounded-[40px]"
                        *ngIf=" selectedProduct.discount_percentage > 0">
                        {{selectedProduct.discount_percentage}}% Off
                      </span>
                    </div>

                    <div class="flex gap-1 justify-center items-center sm:mt-2 text-sm max-md:text-xs leading-none">
                      <span class="self-stretch my-auto font-medium text-neutral-500">
                        Sold by:
                      </span>
                      <span class="self-stretch my-auto font-bold text-black">
                        {{ selectedProduct?.seller_name || selectedProduct?.branch_name || 'Unknown Seller' }}
                      </span>
                    </div>

                    <div class="flex gap-1 justify-center items-center mt-2 text-sm leading-none"
                      *ngIf="selectedProduct.part_type === 'Scrap Part'">
                      <span class="self-stretch my-auto font-medium text-neutral-500">
                        Quantity:
                      </span>
                      <span class="self-stretch my-auto font-bold text-black">
                        {{ parsedData?.quantity || 1 }}
                      </span>
                    </div>
                  </div>
                </div>
              </section>

              <section
                class="flex flex-col justify-center p-3 mt-4 w-full font-bold rounded-lg sm:border sm:border-solid bg-blue-200 bg-opacity-10 sm:border-[color:var(--Secondary-Blue,#307FE1)] max-w-[545px] max-md:max-w-full">
                <div class="flex gap-10 justify-between items-start w-full max-md:max-w-full">
                  <div class="flex gap-2 items-start">
                    <img
                      src="https://cdn.builder.io/api/v1/image/assets/TEMP/91c3182057be68b6244cb7eda4f812725f62dbd1?placeholderIfAbsent=true&apiKey=7a515686e3e54f1fa59f8a8a2c80ed68"
                      class="object-contain shrink-0 w-6 aspect-square" alt="Coupon icon" />
                    <div class="flex flex-col justify-center" *ngIf="!selectedCoupon">
                      <h3 class="text-base text-blue-950">
                        Apply Coupon
                      </h3>
                      <p class="mt-1 text-sm leading-none text-emerald-800">
                        {{ availableCoupons.length > 0 ? availableCoupons.length + '+ Coupons available' : 'Coupons
                        available' }}
                      </p>
                    </div>
                    <div class="flex flex-col justify-center" *ngIf="selectedCoupon">
                      <h3 class="text-base text-blue-950">
                        {{ selectedCoupon?.coupon_code }}
                      </h3>
                      <p class="mt-1 text-sm leading-none text-emerald-800">
                        You saved ₹{{ selectedCoupon?.savings }}
                      </p>
                    </div>
                  </div>
                  <button
                    class="flex gap-1 justify-center items-center text-base text-center text-blue-500 rounded-xl cursor-pointer"
                    (click)="couponmodel()">
                    <span class="gap-2 self-stretch my-auto text-blue-500">
                      {{ selectedCoupon ? 'Change' : 'View All' }}
                    </span>
                  </button>
                </div>
              </section>

              <!-- Available Offers Section -->
              <!-- <section class="mt-4 w-full max-w-[545px] max-md:max-w-full" *ngIf="availableCoupons.length > 0 && !selectedCoupon">
                <h3 class="text-base font-medium mb-3 text-blue-950">Available Offers</h3>
                <div class="space-y-2">
                  <div 
                    *ngFor="let coupon of availableCoupons.slice(0, 2)"
                    class="flex items-center justify-between p-3 bg-green-50 border border-dashed border-green-300 rounded-lg"
                  >
                    <div class="flex items-center gap-2 flex-1">
                      <svg class="w-5 h-5 text-green-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                      </svg>
                      <div class="flex-1 min-w-0">
                        <p class="text-sm font-semibold text-gray-800 truncate">{{ coupon?.coupon_code }}</p>
                        <p class="text-xs text-gray-600 truncate">{{ coupon?.display_text }}</p>
                      </div>
                    </div>
                    <button 
                      (click)="copyToClipboard(coupon?.coupon_code)"
                      class="ml-2 p-1.5 hover:bg-green-100 rounded transition-colors flex-shrink-0"
                      title="Copy coupon code"
                    >
                      <svg class="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"></path>
                      </svg>
                    </button>
                  </div>
                </div>
              </section> -->

              <section class="mt-4 w-full text-sm text-black max-md:max-w-full">
                <div class="w-full max-md:max-w-full">
                  <div class="flex flex-wrap gap-10 justify-between items-center w-full leading-none max-md:max-w-full"
                    *ngIf="getBasePrice() > 0">
                    <span class="self-stretch my-auto font-medium text-black">
                      Sub Total
                    </span>
                    <span class="self-stretch my-auto font-bold text-black">
                      {{ formatCurrency(getBasePrice()) }}
                    </span>
                  </div>

                  <div class="flex flex-wrap gap-10 justify-between items-center w-full leading-none max-md:max-w-full"
                    *ngIf="selectedProduct?.price_breakup?.scrap_booking_amount > 0">
                    <span class="self-stretch my-auto font-medium text-black">
                      Scrap Booking Amount
                      <span *ngIf="getBookingPercentage()" class="text-xs font-bold text-blue-600 ml-1">
                        ({{ getBookingPercentage() }}%)
                      </span>
                    </span>
                    <span class="self-stretch my-auto font-bold text-black">
                      {{ formatCurrency(selectedProduct?.price_breakup?.scrap_booking_amount) }}
                    </span>
                  </div>

                  <label *ngIf="hasBookingAmount()" class="flex items-start gap-2 mt-3 w-full cursor-pointer">
                    <input type="checkbox" class="mt-0.5 w-4 h-4 rounded border border-gray-300"
                      [checked]="payFullAmount" (change)="onPayFullAmountChange($event)"
                      aria-label="Pay full amount now" />
                    <span class="text-sm text-black">
                      Pay full amount now instead of booking amount.
                    </span>
                  </label>

                  <div *ngIf="hasBookingAmount() && !payFullAmount && getBalanceAmount() > 0"
                    class="flex items-start gap-2 mt-3 w-full p-2.5 bg-blue-50/70 rounded-lg border border-blue-100 text-[#0A0A5F]">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" class="mt-0.5 shrink-0 text-blue-700">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                      <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
                    </svg>
                    <p class="text-[#0A0A5F] font-medium text-xs leading-relaxed">
                      The balance amount of {{ formatCurrency(getBalanceAmount()) }} is to be paid at the time of store pickup.
                    </p>
                  </div>

                  <div
                    class="pb-2 mt-2 w-full font-medium leading-none text-black border-b border-solid border-b-[color:var(--Input-field-Stroke,#D4D4D4)] max-md:max-w-full">
                    <div
                      class="flex sm:flex-row max-md:flex-row gap-10 justify-between items-center w-full max-md:max-w-full">
                      <div class="flex gap-2 items-center self-stretch my-auto min-w-60 w-[287px]">
                        <span class="self-stretch my-auto text-black">
                          Taxes and Charges
                        </span>
                        <img
                          src="https://cdn.builder.io/api/v1/image/assets/TEMP/b47c0f886e10dabe3a8cfcabfe6a49b2427c1b45?placeholderIfAbsent=true&apiKey=7a515686e3e54f1fa59f8a8a2c80ed68"
                          class="object-contain shrink-0 self-stretch my-auto w-5 aspect-square cursor-pointer transition-transform duration-300 ease-in-out"
                          [class.rotate-180]="showTaxBreakdown" alt="Info icon" (click)="toggleTaxBreakdown()" />
                      </div>
                      <span class="self-stretch my-auto text-black whitespace-nowrap">
                        + {{
                        formatCurrency(
                        (+selectedProduct?.price_breakup?.delivery_charges || 0) +
                        (+selectedProduct?.price_breakup?.gst_amount || 0) +
                        (+selectedProduct?.price_breakup?.platform_charges || 0) +
                        (+selectedProduct?.price_breakup?.tcs_amount || 0)

                        )
                        }}
                      </span>
                    </div>

                    <!-- Tax Breakdown Details -->
                    <div *ngIf="showTaxBreakdown"
                      class="mt-3 pt-3 border-t border-solid border-t-[color:var(--Input-field-Stroke,#D4D4D4)]">
                      <div class="space-y-2 text-sm">
                        <div class="flex justify-between items-center"
                          *ngIf="selectedProduct?.price_breakup?.discount && +selectedProduct?.price_breakup?.discount > 0">
                          <span class="text-gray-600">Discount on Base Price</span>
                          <span class="text-green-600">- {{ formatCurrency(+selectedProduct?.price_breakup?.discount)
                            }}</span>
                        </div>
                        <div class="flex justify-between items-center"
                          *ngIf="selectedProduct?.price_breakup?.offer_discount && +selectedProduct?.price_breakup?.offer_discount > 0">
                          <span class="text-gray-600">Offer Discount</span>
                          <span class="text-green-600">- {{
                            formatCurrency(+selectedProduct?.price_breakup?.offer_discount) }}</span>
                        </div>
                        <div class="flex justify-between items-center"
                          *ngIf="selectedProduct?.price_breakup?.platform_charges && +selectedProduct?.price_breakup?.platform_charges > 0">
                          <span class="text-gray-600">Platform Charges</span>
                          <span class="text-black">+ {{
                            formatCurrency(+selectedProduct?.price_breakup?.platform_charges) }}</span>
                        </div>
                        <div class="flex justify-between items-center"
                          *ngIf="selectedProduct?.price_breakup?.delivery_charges && +selectedProduct?.price_breakup?.delivery_charges > 0">
                          <span class="text-gray-600">Delivery Charges</span>
                          <span class="text-black">+ {{
                            formatCurrency(+selectedProduct?.price_breakup?.delivery_charges) }}</span>
                        </div>
                        <div class="flex justify-between items-center"
                          *ngIf="selectedProduct?.price_breakup?.gst_amount && +selectedProduct?.price_breakup?.gst_amount > 0">
                          <span class="text-gray-600">GST</span>
                          <span class="text-black">+ {{ formatCurrency(+selectedProduct?.price_breakup?.gst_amount)
                            }}</span>
                        </div>
                        <div class="flex justify-between items-center"
                          *ngIf="selectedProduct?.price_breakup?.tcs_amount && +selectedProduct?.price_breakup?.tcs_amount > 0">
                          <span class="text-gray-600">TCS</span>
                          <span class="text-black">+ {{ formatCurrency(+selectedProduct?.price_breakup?.tcs_amount)
                            }}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="flex flex-wrap gap-10 justify-between items-center mt-2 w-full text-base font-bold min-h-6 max-md:max-w-full">
                    <span class="self-stretch my-auto text-black">
                      Total Amount
                    </span>
                    <span class="self-stretch my-auto text-black">
                      {{ formatCurrency(getPayableAmount()) }}
                    </span>
                  </div>

                  <div *ngIf="paymentErrorMessage"
                    class="mt-2 px-3 py-2 rounded-lg bg-red-50 border border-red-200 text-red-700 text-sm">
                    {{ paymentErrorMessage }}
                  </div>
                  <button (click)="onMakeEnquiry()" [class.opacity-60]="!isReadyForPayment()"
                    [disabled]="!isReadyForPayment()"
                    class="hidden md:flex gap-1 justify-center items-center px-3 py-3 mt-2 w-full text-base font-bold text-center text-white rounded-lg bg-blue-950 max-md:max-w-full cursor-pointer">
                    <span class="gap-2 self-stretch my-auto text-white">
                      Enquire Now
                    </span>
                  </button>

                  <!-- Desktop & Tablet Payment Button -->
                  <button (click)="onMakePayment()"
                    class="hidden md:flex gap-1 justify-center items-center px-3 py-3 mt-2 w-full text-base font-bold text-center text-white rounded-lg bg-blue-950 max-md:max-w-full cursor-pointer"
                    [class.opacity-60]="!isReadyForPayment()" [disabled]="!isReadyForPayment()">
                    <span class="gap-2 self-stretch my-auto text-white">
                      Make Payment
                    </span>
                  </button>

                  <!-- Mobile Fixed Bottom Payment Bar -->
                  <div
                    class="fixed inset-x-0 bottom-0 z-50 bg-white border-t border-[color:var(--Input-field-Stroke,#D4D4D4)] px-4 py-3 md:hidden">
                    <div *ngIf="paymentErrorMessage"
                      class="mb-2 px-3 py-2 rounded-lg bg-red-50 border border-red-200 text-red-700 text-xs max-w-[545px] mx-auto">
                      {{ paymentErrorMessage }}
                    </div>
                    <div class="flex items-center justify-between gap-3 max-w-[545px] mx-auto">
                      <div class="flex flex-col min-w-0">
                        <span class="text-xs font-medium text-gray-600">
                          Total Amount
                        </span>
                        <span class="text-base font-bold text-black truncate">
                          {{ formatCurrency(getPayableAmount()) }}
                        </span>
                      </div>
                      <div class="flex items-center gap-2">
                        <button (click)="onMakeEnquiry()" [class.opacity-60]="!isReadyForPayment()"
                          [disabled]="!isReadyForPayment()"
                          class="flex-shrink-0 px-3 py-3 text-xs sm:text-sm font-bold text-center text-white rounded-lg bg-blue-950 cursor-pointer">
                          Enquire Now
                        </button>
                        <button (click)="onMakePayment()"
                          class="flex-shrink-0 px-3 sm:px-4 py-3 text-xs sm:text-sm font-bold text-center text-white rounded-lg bg-blue-950 cursor-pointer"
                          [class.opacity-60]="!isReadyForPayment()" [disabled]="!isReadyForPayment()">
                          Make Payment
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </article>
        </div>
        <div class="ml-5 w-[57%] max-md:ml-0 max-md:w-full">
          @if(deliveryform && userData?.shipping_address?.address_1){
          <section class="bg-white rounded-2xl border border-[color:var(--Input-field-Stroke,#D4D4D4)] p-6">
            <div class="flex justify-between items-start w-full">
              <h2 class="text-2xl font-bold"> {{userData?.shipping_address?.address_1 &&
                userData?.billing_address?.address_1 ? 'Address Details' : 'Delivery Details'}}</h2>
              <button (click)="editDeliveryDetails('shipping')"
                class="px-6 py-2 max-md:py-1 text-[#0A0A5F] font-semibold rounded-lg border border-[#0A0A5F] hover:bg-blue-500 cursor-pointer">
                Change
              </button>
            </div>


            <!-- Saved Delivery Details -->
            <div class="mt-4">
              <div class="flex items-center gap-2">
                <h3 class="text-lg font-semibold text-ellipsis-1-line overflow-hidden"> <span
                    class="text-[#0A0A5F]">Deliver to:</span>{{userData?.shipping_address?.receiver_name ?
                  userData?.shipping_address?.receiver_name : userData?.shipping_address?.company_name
                  ?userData?.shipping_address?.company_name : userData?.first_name + ' ' + userData?.last_name }}
                  {{userData?.shipping_address?.pincode}}</h3>
                <span
                  class="px-2 py-0.5 text-sm sm:bg-gray-100 text-gray-600 rounded max-md:border max-md: rounded-full"
                  *ngIf="userData?.shipping_address?.address_type">{{userData?.shipping_address?.address_type |
                  titlecase}}</span>
              </div>
              <p class="mt-2 text-gray-400 text-sm" *ngIf="userData?.shipping_address?.address_1">
                {{userData?.shipping_address?.address_1}},
                {{userData?.shipping_address?.land_mark }}, {{userData?.shipping_address?.city}},
                {{userData?.shipping_address?.state }}, {{userData?.shipping_address?.pincode}}</p>
            </div>

            <div class="mt-4" *ngIf="userData?.billing_address?.address_1">
              <div class="flex items-center gap-2">
                <h3 class="text-lg font-semibold text-ellipsis-1-line overflow-hidden"> <span
                    class="text-[#0A0A5F]">Billing to:</span>{{userData?.billing_address?.company_name ?
                  userData?.billing_address?.company_name : userData?.billing_address?.company_name
                  ?userData?.billing_address?.company_name : (userData?.billing_address?.receiver_name ?
                  userData?.billing_address?.receiver_name : (userData?.first_name + ' ' + userData?.last_name)) }}
                  {{userData?.billing_address?.pincode}}</h3>
                <!-- <h3 class="text-lg font-semibold" *ngIf="userData?.billing_address?.company_name">{{userData?.billing_address?.company_name}}</h3> -->
                <span
                  class="px-2 py-0.5 text-sm sm:bg-gray-100 text-gray-600 rounded max-md:border max-md: rounded-full"
                  *ngIf="userData?.billing_address?.address_type">{{userData?.billing_address?.address_type |
                  titlecase}}</span>
              </div>
              <p class="mt-2 text-gray-400 text-sm" *ngIf="userData?.billing_address?.address_1">
                {{userData?.billing_address?.address_1}},
                {{userData?.billing_address?.land_mark }}, {{userData?.billing_address?.city}},
                {{userData?.billing_address?.state }}, {{userData?.billing_address?.pincode}}</p>

              <p class="flex items-center gap-2" *ngIf="userData?.billing_address?.gstin_number">
                <span class="text-[#0A0A5F]">GST: {{userData?.billing_address?.gstin_number}}</span>

              </p>
            </div>
          </section>
          } @else if(isStorePickup) {
          <!-- Shipment Details for Store Pickup -->
          <section class="rounded-2xl border border-solid p-6 max-md:p-3 max-md:bg-white max-md:border-gray-300"
            [class.bg-[#F5F9FE]]="isStorePickup && !addBillingInfo"
            [class.border-[color:var(--Secondary-Blue,#307FE1)]]="isStorePickup && !addBillingInfo"
            [class.bg-white]="!(isStorePickup && !addBillingInfo)"
            [class.border-[color:var(--Input-field-Stroke,#D4D4D4)]]="!(isStorePickup && !addBillingInfo)">
            <div class="flex justify-between items-center">
              <h2 class="text-2xl max-md:text-xl font-bold mb-4 whitespace-nowrap">Shipment Details</h2>
              <button
                class="px-8 py-2 max-md:py-0 max-md:px-4 text-[#0A0A5F] font-semibold border border-[#0A0A5F] rounded-lg bg-white-950 cursor-pointer whitespace-nowrap"
                *ngIf="addBillingInfo && isContinue && !userData?.billing_address?.address_1"
                (click)="toggleBillingDetails('billing')">
                Add Billing Info
              </button>

              <button
                class="px-8 py-2 max-md:py-0 max-md:px-4 text-[#0A0A5F] font-semibold border border-[#0A0A5F] rounded-lg bg-white-950 cursor-pointer whitespace-nowrap"
                *ngIf="userData?.billing_address?.address_1" (click)="editBillingDetails('billing')">
                Edit Billing Info
              </button>
            </div>
            <!-- Store Pickup Address -->
            <div class="mt-4 flex justify-between items-center max-md:mt-0">
              <div class="items-center gap-2">
                <h3 class="text-lg font-semibold"> <span class="text-[#0A0A5F]">Store Pickup at:</span>
                  {{sellerDetails.name}}</h3>
                <p class="mt-2 text-gray-600 text-sm">{{sellerDetails.address}} </p>
              </div>



            </div>

            <!-- <div class="mt-4" *ngIf="userData?.billing_address?.address_1">
              <div class="flex items-center gap-2">
                <h3 class="text-lg font-semibold"> <span class="text-[#0A0A5F]">Billing to:</span>{{userData?.billing_address?.company_name ? userData?.billing_address?.company_name : (userData?.billing_address?.receiver_name ? userData?.billing_address?.receiver_name : (userData?.first_name + ' ' + userData?.last_name)) }}
                  {{userData?.billing_address?.pincode}},</h3>
                <span
                  class="px-2 py-0.5 text-sm sm:bg-gray-100 text-gray-600 rounded max-md:border max-md: rounded-lg" *ngIf="userData?.billing_address?.address_type">{{userData?.billing_address?.address_type | titlecase}}</span>
              </div>
              <p class="mt-2 text-gray-600 text-sm" *ngIf="userData?.billing_address?.address_1">{{userData?.billing_address?.address_1}},
                {{userData?.billing_address?.land_mark }}, {{userData?.billing_address?.city}}, {{userData?.billing_address?.state }}, {{userData?.billing_address?.pincode}}</p>
                 <p class="mt-2 text-gray-600 text-sm" *ngIf="userData?.billing_address?.address_1"> GST: {{userData?.billing_address?.gst_number}}</p>
            </div> -->

            <!-- Billing Options -->
            <div
              class="flex justify-between items-center mt-6 w-full text-base font-bold text-black max-md:flex-col max-md:gap-2 max-md:items-start "
              *ngIf="!userData?.billing_address?.address_1 && !isContinue">
              <div class="flex gap-2 items-center max-md:flex-col max-md:gap-2 max-md:items-start">
                <div class="flex items-center gap-2 ">
                  <input type="radio" id="billing" name="invoiceOption" value="billing"
                    (change)="toggleBillingDetails('billing')" [checked]="showBillingDetails"
                    class="w-4 h-4 accent-blue-950" />
                  <label for="billing" class="text-black">
                    Add different Billing details
                  </label>
                </div>

                <div class="flex items-center gap-2" *ngIf="canAddGstDetails">
                  <input type="radio" id="gstin" name="invoiceOption" value="gstin" (change)="toggleGSTINInvoice()"
                    [checked]="showGSTINInvoice" class="w-4 h-4 accent-blue-950" />
                  <label for="gstin" class="text-black">
                    Add GSTIN
                  </label>
                </div>
              </div>

              <button
                class="px-8 py-2 text-white font-semibold border border-black rounded-lg bg-blue-950 cursor-pointer max-md:w-full"
                *ngIf="!addBillingInfo && !isContinue" (click)="openPersonal()">
                Continue
              </button>
            </div>

            @if(showBillingDetails) {
            <!-- Billing Details Form -->
            <div class="mt-4 p-4 max-md:p-0 bg-gray-50 rounded-lg max-md:bg-transparent"
              *ngIf="userData?.billing_address?.address_type">
              <!-- <h3 class="text-lg font-semibold mb-4">Billing Details</h3> -->
              <!-- Add your billing details form here -->
              <div class="mt-4">
                <div class="flex items-center gap-2">
                  <h3 class="text-lg font-semibold whitespace-nowrap"><span
                      class="text-[#0A0A5F] whitespace-nowrap overflow-hidden">Billing to:
                    </span>{{userData?.billing_address?.company_name ? userData?.billing_address?.company_name :
                    userData?.billing_address?.company_name ?userData?.billing_address?.company_name :
                    userData?.first_name + ' ' + userData?.last_name }}
                    {{userData?.billing_address?.pincode}}</h3>
                  <!-- <h3 class="text-lg font-semibold" *ngIf="userData?.billing_address?.company_name">{{userData?.billing_address?.company_name}}</h3> -->
                  <span
                    class="px-2 py-0.5 text-sm sm:bg-gray-100 text-gray-600 rounded max-md:border max-md: rounded-full"
                    *ngIf="userData?.billing_address?.address_type">{{userData?.billing_address?.address_type |
                    titlecase}}</span>
                </div>
                <p class="mt-2 text-gray-400 text-sm" *ngIf="userData?.billing_address?.address_1">
                  {{userData?.billing_address?.address_1}},
                  {{userData?.billing_address?.land_mark }}, {{userData?.billing_address?.city}},
                  {{userData?.billing_address?.state }}, {{userData?.billing_address?.pincode}}</p>

                @if(userData?.billing_address?.gstin_number){
                <p class="mt-2 text-[13px] text-gray-800">
                  GST: {{ userData?.billing_address?.gstin_number }}
                </p>
                }
              </div>
            </div>
            }

            <!-- @if(showGSTINInvoice) { -->
            <!-- GSTIN Invoice Form -->
            <!-- Add your GSTIN form here -->
            <!-- <div class="mt-4 p-4 bg-gray-50 rounded-lg">
              <h3 class="text-lg font-semibold mb-4">GSTIN Details</h3>
              <div class="mt-4">
                <div class="flex items-center gap-2">
                  <h3 class="text-lg font-semibold">Deliver to:{{userData?.billing_address?.receiver_name ? userData?.billing_address?.receiver_name : userData?.first_name + ' ' + userData?.last_name }}
                    {{userData?.billing_address?.pincode}},</h3>
                  <h3 class="text-lg font-semibold" *ngIf="userData?.billing_address?.company_name">{{userData?.billing_address?.company_name}}</h3>
                  <span
                    class="px-2 py-0.5 text-sm sm:bg-gray-100 text-gray-600 rounded max-md:border max-md: rounded-lg" *ngIf="userData?.billing_address?.address_type">{{userData?.billing_address?.address_type | titlecase}}</span>
                </div>
                <p class="mt-2 text-gray-600 text-sm" *ngIf="userData?.billing_address?.address_1">{{userData?.billing_address?.address_1}},
                  {{userData?.billing_address?.land_mark }}, {{userData?.billing_address?.city}}, {{userData?.billing_address?.state }}, {{userData?.billing_address?.pincode}}</p>
                  @if(userData?.gstin_number){
                    <p class="mt-2 text-[13px] text-gray-800">
                      GST: {{ userData?.gstin_number }}
                    </p>
                    }
                </div>
            </div>
            } -->
          </section>
          } @else {
          <section
            class="flex overflow-hidden flex-col justify-center p-8 mx-auto w-full rounded-2xl border border-solid bg-slate-50 border-[color:var(--Secondary-Blue,#307FE1)] max-md:px-5 max-md:mt-6 max-md:max-w-full">
            <div class="w-full max-md:max-w-full">
              <div class="flex relative flex-wrap gap-4 items-start w-full max-md:max-w-full">
                <div class="z-0 grow shrink text-black min-w-60 w-[640px] max-md:max-w-full">
                  <h2 class="gap-4 self-stretch w-full text-2xl font-bold leading-none text-black max-md:max-w-full">
                    <!-- {{ billingType === 'billing' ? 'Billing Details' : 'Delivery Details' }} -->
                    Delivery Details
                  </h2>
                  <p class="mt-1 text-sm font-medium leading-none text-black opacity-60">
                    {{ billingType === 'billing' ? 'Add your billing address details.' : 'Delivery details and billing
                    details will be the same.' }}
                  </p>
                </div>

                <form [formGroup]="addressForm" class="z-0 grow shrink min-w-60 w-[640px] max-md:max-w-full">
                  <!-- Receiver Name (only for shipping) -->
                  <div class="mb-4 max-sm:hidden" *ngIf="type === 'shipping'">
                    <label
                      class="flex-1 shrink gap-2.5 self-stretch w-full text-sm font-bold leading-none basis-0 text-zinc-700 max-md:max-w-full">
                      Receiver's Name
                    </label>
                    <div
                      class="flex gap-2 items-center mt-1 w-full text-base font-medium text-black rounded-lg border border-solid"
                      [class.border-red-500]="addressForm.get('receiverName')?.invalid && addressForm.get('receiverName')?.touched"
                      [class.border-gray-300]="!(addressForm.get('receiverName')?.invalid && addressForm.get('receiverName')?.touched)">
                      <input type="text" pattern="^(?! )[\w\W]*$" (keydown)="preventLeadingSpace($event, $event.target)"
                        formControlName="receiverName" placeholder="Enter receiver's name"
                        class="flex-1 shrink gap-2.5 self-stretch my-auto w-full rounded-lg text-black basis-0 min-w-60 max-md:max-w-full bg-transparent border-none outline-none" />
                    </div>

                    <div *ngIf="addressForm.get('receiverName')?.invalid && addressForm.get('receiverName')?.touched"
                      class="text-red-500 text-xs mt-1">
                      Receiver name is required
                    </div>
                  </div>

                  <div class="flex items-center justify-between mb-4 md:hidden">
                    <!-- Label -->
                    <label class="text-md font-bold text-black">
                      Location
                    </label>

                    <!-- Current Location -->
                    <div class="flex items-center gap-2 text-sm font-medium text-blue-500 cursor-pointer"
                      (click)="getUserLocation()">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 19C8.13401 19 5 15.866 5 12M12 19C15.866 19 19 15.866 19 12M12 19V22M5 12C5 8.13401
                        8.13401 5 12 5M5 12H2M19 12C19 8.13401 15.866 5 12 5M19 12H22M12 5V2M12 14C10.8954 14 10 13.1046
                        10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14Z"
                          stroke="#307FE1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      <span>Current Location</span>
                    </div>
                  </div>


                  <!-- Company Name (only for billing) -->
                  <div class="mb-4" *ngIf="type === 'billing'">
                    <label
                      class="flex-1 shrink gap-2.5 self-stretch w-full text-sm font-bold leading-none basis-0 text-zinc-700 max-md:max-w-full">
                      Company Name
                    </label>
                    <div
                      class="flex gap-2 items-center mt-1 w-full text-base font-medium text-black rounded-lg border border-solid"
                      [ngClass]="{
                      'border-red-500': addressForm.get('companyName')?.invalid && addressForm.get('companyName')?.touched,
                      'border-[color:var(--Input-field-Stroke,#D4D4D4)]': !(addressForm.get('companyName')?.invalid && addressForm.get('companyName')?.touched)
                    }">
                      <input type="text" formControlName="companyName" pattern="^(?! )[\w\W]*$"
                        (keydown)="preventLeadingSpace($event, $event.target)" placeholder="Enter company name"
                        class="flex-1 shrink gap-2.5 self-stretch my-auto w-full rounded-lg text-black min-w-60 max-md:max-w-full bg-transparent border-none outline-none" />
                    </div>

                  </div>

                  <div class="mb-4">
                    <label
                      class="flex-1 shrink gap-2.5 self-stretch w-full text-sm font-bold leading-none basis-0 text-zinc-700 max-md:max-w-full">
                      Flat, House no., Building, Company, Apartment
                    </label>
                    <div
                      class="flex gap-2 items-center mt-1 w-full text-base font-medium text-black rounded-lg border border-solid"
                      [ngClass]="{
                      'border-red-500': addressForm.get('flatHouseNo')?.invalid && addressForm.get('flatHouseNo')?.touched,
                      'border-[color:var(--Input-field-Stroke,#D4D4D4)]': !(addressForm.get('flatHouseNo')?.invalid && addressForm.get('flatHouseNo')?.touched)
                    }">
                      <input type="text" formControlName="flatHouseNo" placeholder="Enter flat/house number"
                        pattern="^(?! )[\w\W]*$" (keydown)="preventLeadingSpace($event, $event.target)"
                        class="flex-1 shrink gap-2.5 self-stretch my-auto w-full rounded-lg text-black min-w-60 max-md:max-w-full bg-transparent border-none outline-none" />
                    </div>

                    <div *ngIf="addressForm.get('flatHouseNo')?.invalid && addressForm.get('flatHouseNo')?.touched"
                      class="text-red-500 text-xs mt-1">
                      <span *ngIf="addressForm.get('flatHouseNo')?.errors?.['required']">Flat/House number is
                        required</span>
                      <span *ngIf="addressForm.get('flatHouseNo')?.errors?.['minlength']">Flat/House number must be at
                        least 2 characters</span>
                    </div>
                  </div>

                  <div class="flex gap-4 mb-4 max-md:flex-col max-md:gap-2">
                    <div class="flex-1 max-md:flex-col max-md:gap-2">
                      <label
                        class="flex-1 shrink gap-2.5 self-stretch w-full text-sm font-bold leading-none whitespace-nowrap basis-0 text-zinc-700">
                        Locality
                      </label>
                      <div
                        class="flex gap-2 items-center mt-1 w-full text-base font-medium text-black rounded-lg border border-solid"
                        [ngClass]="{
                        'border-red-500': addressForm.get('locality')?.invalid && addressForm.get('locality')?.touched,
                        'border-[color:var(--Input-field-Stroke,#D4D4D4)]': !(addressForm.get('locality')?.invalid && addressForm.get('locality')?.touched)
                      }">
                        <input type="text" formControlName="locality" placeholder="Enter locality"
                          pattern="^(?! )[\w\W]*$" (keydown)="preventLeadingSpace($event, $event.target)"
                          class="flex-1 shrink gap-2.5 self-stretch my-auto w-full rounded-lg text-black min-w-60 bg-transparent border-none outline-none" />
                      </div>

                      <div *ngIf="addressForm.get('locality')?.invalid && addressForm.get('locality')?.touched"
                        class="text-red-500 text-xs mt-1">
                        <span *ngIf="addressForm.get('locality')?.errors?.['required']">Locality is required</span>
                        <span *ngIf="addressForm.get('locality')?.errors?.['minlength']">Locality must be at least 2
                          characters</span>
                      </div>
                    </div>

                    <div class="flex-1">
                      <label
                        class="flex-1 shrink gap-2.5 self-stretch w-full text-sm font-bold leading-none basis-0 text-zinc-700">
                        PIN Code
                      </label>
                      <div
                        class="flex gap-2 items-center mt-1 w-full text-base font-medium text-black rounded-lg border border-solid"
                        [ngClass]="{
                        'border-red-500': addressForm.get('pin')?.invalid && addressForm.get('pin')?.touched,
                        'border-[color:var(--Input-field-Stroke,#D4D4D4)]': !(addressForm.get('pin')?.invalid && addressForm.get('pin')?.touched)
                      }">
                        <input type="text" inputmode="numeric" pattern="^[0-9]{6}$" formControlName="pin"
                          placeholder="Enter 6-digit PIN code" maxlength="6"
                          (keydown)="preventNonDigitOrLeadingSpace($event, $event.target)"
                          class="flex-1 shrink gap-2.5 self-stretch my-auto w-full rounded-lg text-black min-w-60 bg-transparent border-none outline-none" />
                      </div>

                      <div *ngIf="addressForm.get('pin')?.invalid && addressForm.get('pin')?.touched"
                        class="text-red-500 text-xs mt-1">
                        <span *ngIf="addressForm.get('pin')?.errors?.['required']">PIN code is required</span>
                        <span *ngIf="addressForm.get('pin')?.errors?.['pattern']">Please enter a valid 6-digit PIN
                          code</span>
                      </div>
                    </div>
                  </div>

                  <div class="flex gap-4 max-md:flex-col max-md:gap-2">
                    <div class="flex-1 max-md:flex-col max-md:gap-2">
                      <label
                        class="flex-1 shrink gap-2.5 self-stretch w-full text-sm font-bold leading-none basis-0 text-zinc-700">
                        State
                      </label>
                      <div
                        class="flex gap-2 items-center mt-1 w-full text-base font-medium text-black rounded-lg border border-solid"
                        [ngClass]="{
    'border-red-500': addressForm.get('state')?.invalid && addressForm.get('state')?.touched,
    'border-[color:var(--Input-field-Stroke,#D4D4D4)]': !(addressForm.get('state')?.invalid && addressForm.get('state')?.touched)
  }">
                        <select formControlName="state"
                          class="flex-1 shrink gap-2.5 self-stretch my-auto w-full rounded-lg text-black min-w-60 bg-transparent border-none outline-none cursor-pointer h-10"
                          style="padding-left: 15px;">
                          <option value="" disabled selected style="color: #9ca3af;">Select state</option>
                          <option *ngFor="let state of states" [value]="state" [selected]="state === selectedState">
                            {{ state }}
                          </option>
                        </select>

                      </div>

                      <div *ngIf="addressForm.get('state')?.invalid && addressForm.get('state')?.touched"
                        class="text-red-500 text-xs mt-1">
                        <span *ngIf="addressForm.get('state')?.errors?.['required']">State is required</span>
                        <span *ngIf="addressForm.get('state')?.errors?.['minlength']">State must be at least 2
                          characters</span>
                      </div>
                    </div>

                    <div class="flex-1">
                      <label
                        class="flex-1 shrink gap-2.5 self-stretch w-full text-sm font-bold leading-none basis-0 text-zinc-700">
                        City/Town
                      </label>
                      <div
                        class="flex gap-2 items-center mt-1 w-full text-base font-medium text-black rounded-lg border border-solid"
                        [ngClass]="{
                        'border-red-500': addressForm.get('city')?.invalid && addressForm.get('city')?.touched,
                        'border-[color:var(--Input-field-Stroke,#D4D4D4)]': !(addressForm.get('city')?.invalid && addressForm.get('city')?.touched)
                      }">
                        <select formControlName="city"
                          class="flex-1 shrink gap-2.5 self-stretch my-auto w-full rounded-lg text-black min-w-60 bg-transparent border-none outline-none cursor-pointer h-10"
                          [disabled]="!selectedState" style="padding-left: 15px;">
                          <option value="" disabled selected style="color: #9ca3af;">Select city</option>
                          <option *ngFor="let city of cities" [value]="city" [selected]="city === selectedCity">
                            {{ city }}
                          </option>
                        </select>

                      </div>

                      <div *ngIf="addressForm.get('city')?.invalid && addressForm.get('city')?.touched"
                        class="text-red-500 text-xs mt-1">
                        <span *ngIf="addressForm.get('city')?.errors?.['required']">City is required</span>
                        <span *ngIf="addressForm.get('city')?.errors?.['minlength']">City must be at least 2
                          characters</span>
                      </div>
                    </div>
                  </div>
                </form>

                <div class="flex absolute right-0 z-0 gap-1 items-center rounded-xl min-h-6 top-[152px]">
                </div>
              </div>

              <!-- Save As Section (only for shipping) -->
              <div class="flex flex-col mt-6 w-full text-black max-md:max-w-full" *ngIf="type === 'shipping'">
                <h3 class="text-lg font-bold leading-none text-black">
                  Save As
                </h3>
                <div class="flex gap-4 items-center self-start mt-4 text-sm font-medium leading-none whitespace-nowrap">
                  <div class="flex gap-2 items-center self-stretch my-auto min-h-9 min-w-60">
                    <button type="button"
                      class="flex gap-1 justify-center items-center self-stretch py-2 pr-3.5 pl-3 my-auto border border-solid min-h-9 rounded-[39px] cursor-pointer"
                      [class.bg-blue-50]="addressForm.get('saveAs')?.value === 'home'"
                      [class.border-[color:var(--Secondary-Blue,#307FE1)]="addressForm.get('saveAs')?.value === 'home'"
                      [class.text-blue-500]="addressForm.get('saveAs')?.value === 'home'"
                      [class.bg-white]="addressForm.get('saveAs')?.value !== 'home'"
                      [class.border-[color:var(--Input-field-Stroke,#D4D4D4)]="addressForm.get('saveAs')?.value !== 'home'"
                      [class.text-black]="addressForm.get('saveAs')?.value !== 'home'"
                      (click)="addressForm.patchValue({saveAs: 'home'})">
                      <img
                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/4f379a520a764aadce28819fdce97ddae276b28f?placeholderIfAbsent=true&apiKey=7a515686e3e54f1fa59f8a8a2c80ed68"
                        class="object-contain shrink-0 self-stretch my-auto w-5 aspect-square" alt="Home icon" />
                      <span class="self-stretch my-auto">
                        Home
                      </span>
                    </button>

                    <button type="button"
                      class="flex gap-1 justify-center items-center self-stretch py-2 pr-3.5 pl-3 my-auto border border-solid min-h-9 rounded-[39px] cursor-pointer"
                      [class.bg-blue-50]="addressForm.get('saveAs')?.value === 'work'"
                      [class.border-[color:var(--Secondary-Blue,#307FE1)]="addressForm.get('saveAs')?.value === 'work'"
                      [class.text-blue-500]="addressForm.get('saveAs')?.value === 'work'"
                      [class.bg-white]="addressForm.get('saveAs')?.value !== 'work'"
                      [class.border-[color:var(--Input-field-Stroke,#D4D4D4)]="addressForm.get('saveAs')?.value !== 'work'"
                      [class.text-black]="addressForm.get('saveAs')?.value !== 'work'"
                      (click)="addressForm.patchValue({saveAs: 'work'})">
                      <img
                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/da8af57af1901e6645c598cc3b4bb801c0870797?placeholderIfAbsent=true&apiKey=7a515686e3e54f1fa59f8a8a2c80ed68"
                        class="object-contain shrink-0 self-stretch my-auto w-5 aspect-square" alt="Work icon" />
                      <span class="self-stretch my-auto">
                        Work
                      </span>
                    </button>

                    <button type="button"
                      class="flex gap-1 justify-center items-center self-stretch py-2 pr-3.5 pl-3 my-auto border border-solid min-h-9 rounded-[39px] cursor-pointer"
                      [class.bg-blue-50]="addressForm.get('saveAs')?.value === 'others'"
                      [class.border-[color:var(--Secondary-Blue,#307FE1)]="addressForm.get('saveAs')?.value === 'others'"
                      [class.text-blue-500]="addressForm.get('saveAs')?.value === 'others'"
                      [class.bg-white]="addressForm.get('saveAs')?.value !== 'others'"
                      [class.border-[color:var(--Input-field-Stroke,#D4D4D4)]="addressForm.get('saveAs')?.value !== 'others'"
                      [class.text-black]="addressForm.get('saveAs')?.value !== 'others'"
                      (click)="addressForm.patchValue({saveAs: 'others'})">
                      <img src="/assets/location.png"
                        class="object-contain shrink-0 self-stretch my-auto w-5 aspect-square" alt="Others icon" />
                      <span class="self-stretch my-auto">
                        Others
                      </span>
                    </button>
                  </div>
                </div>
              </div>
              <section class="mt-6 w-full" *ngIf="addressForm.get('saveAs')?.value === 'others'">
                <div class="w-full">
                  <label class="block text-sm font-bold leading-none text-zinc-700 mb-2">
                    Save address as
                  </label>
                  <input formControlName="saveAsName"
                    class="w-full px-3 py-3 text-base font-medium rounded-lg text-neutral-500 border border-zinc-300 focus:border-blue-500 focus:outline-none bg-transparent"
                    placeholder="Save address as" required />
                  <div *ngIf="addressForm.get('saveAsName')?.invalid && addressForm.get('saveAsName')?.touched"
                    class="text-red-500 text-xs mt-1">
                    This field is required
                  </div>
                </div>
              </section>

              <!-- <div class="mb-4" *ngIf="type === 'shipping'">
                <label
                  class="flex-1 shrink gap-2.5 self-stretch w-full text-sm font-bold leading-none basis-0 text-zinc-700 max-md:max-w-full">
                  Save address as
                </label>
                <div
                class="flex gap-2 items-center mt-1 w-full text-base font-medium text-black rounded-lg border border-solid"
                [class.border-red-500]="addressForm.get('receiverName')?.invalid && addressForm.get('receiverName')?.touched"
                [class.border-gray-300]="!(addressForm.get('receiverName')?.invalid && addressForm.get('receiverName')?.touched)">
                <input
                  type="text"
                  formControlName="receiverName"
                  placeholder="Save address as"
                  class="flex-1 shrink gap-2.5 self-stretch my-auto w-full rounded-lg text-black basis-0 min-w-60 max-md:max-w-full bg-transparent border-none outline-none"
                />
              </div>
              
                <div *ngIf="addressForm.get('receiverName')?.invalid && addressForm.get('receiverName')?.touched"
                  class="text-red-500 text-xs mt-1">
                  Receiver name is required
                </div>
              </div> -->

              <!-- Billing Options (only for shipping) -->
              <div
                class="flex flex-wrap gap-6 items-center mt-6 w-full text-base font-bold text-black max-md:max-w-full"
                *ngIf="type === 'shipping' && !userData?.billing_address?.address_1">
                <div class="flex gap-1 items-center self-stretch my-auto cursor-pointer">
                  <div class="flex gap-2 self-stretch py-0.5 my-auto min-h-6">
                    <input type="radio" id="billing" name="invoiceOption" value="billing"
                      (change)="toggleBillingDetails('billing')" [checked]="showBillingDetails"
                      class="max-md:w-4 max-md:h-4 max-md:accent-blue-950" />
                  </div>
                  <span class="self-stretch my-auto text-black">
                    Add different Billing details
                  </span>
                </div>
                <div class="flex gap-1 items-center self-stretch my-auto cursor-pointer" *ngIf="canAddGstDetails">
                  <div class="flex gap-2 self-stretch py-0.5 my-auto min-h-6">
                    <input type="radio" id="gstin" name="invoiceOption" value="gstin" (change)="toggleGSTINInvoice()"
                      [checked]="showGSTINInvoice" class="max-md:w-4 max-md:h-4 max-md:accent-blue-950" />
                  </div>
                  <span class="self-stretch my-auto text-black">
                    Add GSTIN
                  </span>
                </div>
              </div>
            </div>
            @if(userData?.billing_address) {
            <!-- Billing Details Form -->
            <div class="mt-4 p-4 max-md:p-0 bg-gray-50 rounded-lg max-md:bg-white">
              <div class="flex items-center justify-between mb-4">
                <h3 class="text-lg font-semibold">Billing Details</h3>
                <button *ngIf="userData?.billing_address" (click)="editBillingDetails('billing')"
                  class="px-6 py-2 max-md:py-1 text-[#4178e5] font-semibold rounded-lg cursor-pointer">
                  Change
                </button>
              </div>

              <!-- Add your billing details form here -->
              <div class="mt-4">
                <div class="flex items-center gap-2">
                  <h3 class="text-lg font-semibold text-ellipsis-1-line whitespace-nowrap overflow-hidden"> <span
                      class="text-[#0A0A5F]">Billing to:</span>{{userData?.billing_address?.company_name ?
                    userData?.billing_address?.company_name : userData?.billing_address?.receiver_name
                    ?userData?.billing_address?.receiver_name : userData?.first_name + ' ' + userData?.last_name }}
                    {{userData?.billing_address?.pincode}}</h3>
                  <span
                    class="px-2 py-0.5 text-sm sm:bg-gray-100 text-gray-600 rounded max-md:border max-md: rounded-full"
                    *ngIf="userData?.billing_address?.address_type">{{userData?.billing_address?.address_type |
                    titlecase}}</span>
                </div>
                <p class="mt-2 text-gray-400 text-sm" *ngIf="userData?.billing_address?.address_1">
                  {{userData?.billing_address?.address_1}},
                  {{userData?.billing_address?.land_mark }}, {{userData?.billing_address?.city}},
                  {{userData?.billing_address?.state }}, {{userData?.billing_address?.pincode}}</p>

                @if(userData?.billing_address?.gstin_number){
                <p class="mt-2 text-[13px] text-gray-800">
                  GST: {{ userData?.billing_address?.gstin_number }}
                </p>
                }
              </div>
            </div>
            }

            <button
              class="flex gap-1 justify-center items-center self-end p-2 mt-4 max-w-full text-base font-bold text-center text-white rounded-lg bg-blue-950 min-h-10 w-[164px] max-md:w-full cursor-pointer"
              (click)="saveDeliveryDetails()" [class.opacity-60]="!addressForm.valid" [disabled]="!addressForm.valid">
              <span class="gap-2 self-stretch my-auto text-white">
                Save
              </span>
            </button>
          </section>
          }
          <section class="rounded-2xl border border-solid p-6 mt-6 max-md:p-3" [class.bg-[#F5F9FE]]="showPersonalForm"
            [class.border-[color:var(--Secondary-Blue,#307FE1)]]="showPersonalForm" [class.bg-white]="!showPersonalForm"
            [class.border-[color:var(--Input-field-Stroke,#D4D4D4)]]="!showPersonalForm">
            <div class="flex justify-between items-start w-full">
              <h2 class="text-xl font-bold">Personal Details</h2>
              @if(!showPersonalForm && userData?.first_name && userData?.last_name) {
              <button (click)="editPersonalDetails()"
                class="px-6 py-2 max-md:py-1 text-[#0A0A5F] font-semibold rounded-lg border border-[#0A0A5F] cursor-pointer">
                Change
              </button>

              }
            </div>

            @if(showPersonalForm) {
            <form #personalForm="ngForm" class="space-y-4 mt-4" (ngSubmit)="savePersonalDetails()">
              <!-- Name Fields Row -->
              <div class="grid grid-cols-2 max-md:grid-cols-1 gap-4">
                <div>
                  <label class="block text-sm font-medium mb-1">First Name</label>
                  <input type="text" name="firstName" [(ngModel)]="firstName" required #firstNameInput="ngModel"
                    placeholder="Enter your first name" pattern="^[A-Za-z]+$" inputmode="text"
                    (keydown)="preventNumberAndSpaceInput($event)"
                    class="w-full p-2 border bg-[#F5F9FE] border-[color:var(--Input-field-Stroke,#D4D4D4)] rounded-lg focus:outline-none focus:border-blue-500"
                    [class.border-red-500]="firstNameInput.invalid && firstNameInput.touched" />
                  <div *ngIf="firstNameInput.errors && firstNameInput.errors['pattern'] && firstNameInput.touched"
                    class="text-red-500 text-xs mt-1">
                    Only alphabets are allowed (no special characters).
                  </div>
                </div>
                <div>
                  <label class="block text-sm font-medium mb-1">Last Name</label>
                  <input type="text" name="lastName" [(ngModel)]="lastName" required #lastNameInput="ngModel"
                    placeholder="Enter your last name" pattern="^[A-Za-z]+$" inputmode="text"
                    (keydown)="preventNumberAndSpaceInput($event)"
                    class="w-full p-2 border bg-[#F5F9FE] border-[color:var(--Input-field-Stroke,#D4D4D4)] rounded-lg focus:outline-none focus:border-blue-500"
                    [class.border-red-500]="lastNameInput.invalid && lastNameInput.touched" />
                  <div *ngIf="lastNameInput.errors && lastNameInput.errors['pattern'] && lastNameInput.touched"
                    class="text-red-500 text-xs mt-1">
                    Only alphabets are allowed (no special characters).
                  </div>
                </div>
              </div>

              <!-- Email Field -->
              <div>
                <div class="flex justify-between items-center mb-1">
                  <label class="text-sm font-medium">Email ID</label>
                  <span class="text-xs text-gray-500">(Optional)</span>
                </div>
                <input type="email" name="email" [(ngModel)]="email" #emailInput="ngModel"
                  (keydown)="prevenSpaceInput($event)" placeholder="Enter your email id"
                  pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                  class="w-full p-2 border bg-[#F5F9FE] border-[color:var(--Input-field-Stroke,#D4D4D4)] rounded-lg focus:outline-none focus:border-blue-500"
                  [class.border-red-500]="emailInput.errors && emailInput.errors['pattern'] && emailInput.touched && email" />
                <div *ngIf="emailInput.errors && emailInput.errors['pattern'] && emailInput.touched && email"
                  class="text-red-500 text-xs mt-1">
                  Please enter a valid email address
                </div>
              </div>

              <!-- User Type Selection -->
              <div>
                <label class="block text-sm font-medium mb-1">Who are you?</label>
                <p class="text-xs text-gray-500 mb-2">You can select only one option at a time</p>
                <div class="flex flex-wrap gap-2">
                  <button *ngFor="let type of userTypes" type="button" class="px-3 py-1.5 text-sm border rounded"
                    [class.bg-blue-50]="selectedUserType === type" [class.border-blue-500]="selectedUserType === type"
                    [class.text-blue-500]="selectedUserType === type" (click)="selectUserType(type)">
                    {{type}}
                  </button>
                </div>
              </div>

              <!-- Save Button -->
              <div class="flex justify-end max-md:justify-center max-md:w-full">
                <button type="submit"
                  class="px-8 py-2 text-white font-semibold rounded-lg bg-blue-950 cursor-pointer max-md:w-full"
                  [class.opacity-60]="!isFormValid()" [disabled]="!isFormValid()">
                  Save
                </button>
              </div>
            </form>
            } @else {
            <!-- Personal Details Summary View -->
            <div class="mt-4">
              <div class="flex items-center gap-2">
                <h3 class="text-lg font-semibold">{{userData?.first_name}} {{userData?.last_name}}</h3>
                <span class="px-2 py-0.5 text-sm" *ngIf="userData?.user_type">({{userData?.user_type}})</span>
              </div>
              @if(userData?.email_id) {
              <p class="mt-2 text-gray-600 text-sm">{{userData?.email_id}}</p>
              }
            </div>
            }
          </section>
        </div>
      </div>
    </section>
  </main>
</div>
<app-address *ngIf="showBillingPopup" (save)="onSaveAddressDetails($event)" (close)="onCloseBillingDetails()"
  [type]="billingType" [editingAddress]="editingBillingData" [isEditMode]="!!editingBillingData"></app-address>
<app-gst *ngIf="showGSTINPopup" (close)="onCloseGSTINPopup()" (save)="onSaveGSTINDetails($event)"></app-gst>
<app-coupon *ngIf="showCouponSection" [availableCoupons]="availableCoupons" [currentSelectedCoupon]="selectedCoupon"
  (close)="onCloseCouponPopup()" (save)="onSaveCouponDetails($event)">
</app-coupon>
<div *ngIf="showFullPaymentConfirm"
  class="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50">
  <div class="bg-white rounded-lg shadow-lg max-w-md w-full mx-4 relative">
    <button (click)="cancelFullPayment()" class="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
      aria-label="Close">
      <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
      </svg>
    </button>
    <div class="px-6 pt-6 pb-4">
      <h3 class="text-xl font-bold text-gray-900">Pay full amount?</h3>
    </div>
    <div class="px-6 pb-6">
      <p class="text-gray-700">Are you sure you want to pay the full amount now instead of the booking amount?</p>
    </div>
    <div class="px-6 pb-6 flex gap-3">
      <button (click)="confirmFullPayment()" class="flex-1 px-4 py-2 bg-blue-700 text-white rounded-lg">Yes</button>
      <button (click)="cancelFullPayment()"
        class="flex-1 px-4 py-2 border border-blue-500 text-blue-500 rounded-lg">No</button>
    </div>
  </div>
</div>
<!-- </div> -->